import { C, MONO, STAGE_COLORS, Eyebrow } from "./hubShared";

export const HubGrid = ({ grid, funnel, sel, onPick }) => (
  <div data-testid="hub-grid">
    <Eyebrow>Partner × stage · click a number to open those members</Eyebrow>
    <div style={{ overflowX: "auto", marginTop: 10, background: "#fff", border: "1px solid rgba(26,30,36,0.10)", borderRadius: 10 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5, minWidth: 760 }}>
        <thead>
          <tr style={{ background: C.cream }}>
            <th style={{ textAlign: "left", padding: "10px 14px", fontWeight: 600, color: C.slate }}>Partner</th>
            <th style={{ textAlign: "right", padding: "10px 10px", fontWeight: 600, color: C.slate }}>Total</th>
            {funnel.map((s) => (
              <th key={s.stage} style={{ textAlign: "right", padding: "10px 10px", fontWeight: 600, color: C.slate, whiteSpace: "nowrap" }}>
                <span style={{ display: "inline-block", width: 7, height: 7, borderRadius: 9, background: STAGE_COLORS[s.stage], marginRight: 6 }} />{s.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {grid.map((r) => (
            <tr key={r.partner} style={{ borderTop: "1px solid rgba(26,30,36,0.07)" }} data-testid={`hub-grid-row-${r.partner}`}>
              <td style={{ padding: "10px 14px", fontWeight: 600, color: C.ink }}>{r.partner}</td>
              <td style={{ padding: "10px 10px", textAlign: "right", fontFamily: MONO }}>{r.total}</td>
              {funnel.map((s) => {
                const n = r.stages[s.stage];
                const on = sel.partner === r.partner && sel.stage === s.stage;
                return (
                  <td key={s.stage} style={{ padding: "4px 6px", textAlign: "right" }}>
                    <button disabled={!n} onClick={() => onPick(r.partner, s.stage)} data-testid={`hub-cell-${r.partner}-${s.stage}`}
                      style={{ fontFamily: MONO, fontSize: 12.5, padding: "6px 9px", borderRadius: 6, border: 0, minWidth: 44,
                        cursor: n ? "pointer" : "default", color: on ? "#fff" : n ? C.ink : "#B8C0C8",
                        background: on ? C.navy : n ? `${STAGE_COLORS[s.stage]}${Math.min(60, 10 + Math.round((n / Math.max(r.total, 1)) * 60)).toString(16).padStart(2, "0")}` : "transparent",
                        transition: "background-color 0.15s ease, color 0.15s ease" }}>
                      {n}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
          {grid.length === 0 && <tr><td colSpan={9} style={{ padding: 20, color: C.slate }}>No members match these filters.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);
